import React, { useEffect } from 'react';
import Selector from './Selector';
import logo from '../logo.svg';

const Header = ({ org, setOrg, project, setProject, projectOptions, email, profileOpen, setProfileOpen, profileRef, orgOptions, onLogout }) => {
  // Use first two initials of email for avatar
  let initials = 'ST';
  if (email) {
    const namePart = email.split('@')[0];
    initials = namePart.slice(0, 2).toUpperCase();
  }
  const profileImg = `https://ui-avatars.com/api/?name=${initials}&background=1db954&color=fff&rounded=true&size=48`;

  useEffect(() => {
    if (!profileOpen) return;
    function handleClick(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [profileOpen, profileRef, setProfileOpen]);

  return (
    <div className="header new-header">
      <div className="header-logo" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <img src={logo} alt="Stanverse Logo" style={{ width: 38, height: 38, marginRight: 8 }} />
        <span style={{ fontWeight: 900, fontSize: '1.35rem', color: '#222', marginLeft: 0 }}>
          Stanverse Technologies Pvt Ltd
        </span>
      </div>
      <div className="header-right">
        <Selector
          value={org}
          options={orgOptions}
          onChange={setOrg}
          label="Org"
          pill={<span className="selector-green-pill">Org</span>}
        />
        <Selector
          value={project}
          options={projectOptions}
          onChange={setProject}
          label="Project"
          pill={<span className="selector-green-pill">Project</span>}
        />
        <div className="header-profile-wrapper" ref={profileRef}>
          <img
            src={profileImg}
            alt="Profile"
            className="header-profile-avatar"
            onClick={() => setProfileOpen((v) => !v)}
            tabIndex={0}
            style={{ cursor: 'pointer' }}
          />
          {profileOpen && (
            <div className="header-profile-dropdown">
              <div className="header-profile-dropdown-item" style={{ fontWeight: 500, color: '#222', cursor: 'default' }}>{email}</div>
              <div className="header-profile-dropdown-item" style={{ color: '#e53935', fontWeight: 700, cursor: 'pointer' }} onClick={onLogout}>Logout</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header; 